import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Basics } from '../../../components/HelpContent/Basics';
import NotesWrapper from '../../../components/NotesLayout/NotesLayout';
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 2.5vw;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Help() {
    return(/*#__PURE__*/ _jsx(HelpContainer, {
        children: /*#__PURE__*/ _jsx(Basics, {})
    }));
}
var HelpContainer = styled.div(_templateObject());
Help.layout = NotesWrapper;
export default Help;
